import "../../index11.css";
import { jsxs as k, jsx as t } from "react/jsx-runtime";
import { useMemo as v } from "react";
import { a as y } from "../../core-DVmjA3_O.js";
import { _ as o } from "../../cs-Dfox81s-.js";
import "../../type-Dku6Xzl6.js";
import f from "../../hooks/useSpacingToken.js";
import { gapSpacings as p, fullSpacings as O } from "../../utils/style.js";
const L = "_block-layout_1emxe_1", j = "_children_1emxe_5", B = "_separator_1emxe_9", M = "_after-content_1emxe_15", P = "_before-content_1emxe_16", e = {
  blockLayout: L,
  children: j,
  separator: B,
  afterContent: M,
  beforeContent: P
};
function F(d) {
  const {
    className: h,
    elementRef: C,
    before: a,
    children: n,
    after: s,
    beforeContainerClassName: _,
    childrenContainerClassName: u,
    afterContainerClassName: N,
    spacing: i,
    spacingOffset: c,
    withPadding: l,
    withBeforeSeparator: g,
    withAfterSeparator: b,
    withoutSpacingOpticalCorrection: m,
    ...x
  } = d, w = v(() => l ? O : p, [l]), S = f({
    spacing: i,
    modes: w,
    offset: c,
    withoutOpticalCorrection: m
  }), r = f({
    spacing: i,
    modes: p,
    offset: c,
    withoutOpticalCorrection: m
  });
  return /* @__PURE__ */ k(
    "div",
    {
      ...x,
      className: o(
        e.blockLayout,
        S,
        h
      ),
      ref: C,
      children: [
        a && /* @__PURE__ */ t(
          "div",
          {
            className: o(
              e.beforeContent,
              r,
              _
            ),
            children: a
          }
        ),
        g && /* @__PURE__ */ t("hr", { className: e.separator }),
        y(n) && /* @__PURE__ */ t(
          "div",
          {
            className: o(
              e.children,
              r,
              u
            ),
            children: n
          }
        ),
        b && /* @__PURE__ */ t("hr", { className: e.separator }),
        s && /* @__PURE__ */ t(
          "div",
          {
            className: o(
              e.afterContent,
              N,
              r
            ),
            children: s
          }
        )
      ]
    }
  );
}
export {
  F as default
};
